/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TGetNewbuildingPromoPinsForMapRequest,
  TGetNewbuildingPromoPinsForMapModel,
  IMappers,
  TGetNewbuildingPromoPinsForMapResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetNewbuildingPromoPinsForMapResponseSchema } from '../../entities/get_newbuilding_promo_pins_for_map/GetNewbuildingPromoPinsForMapResponseSchema';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createGetNewbuildingPromoPinsForMapModel(
  parameters: TGetNewbuildingPromoPinsForMapRequest,
): TGetNewbuildingPromoPinsForMapModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'search-offers-index',
    pathApi: '/v1/get-newbuilding-promo-pins-for-map/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IGetNewbuildingPromoPinsForMapOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TGetNewbuildingPromoPinsForMapRequest;
}

export async function fetchGetNewbuildingPromoPinsForMap<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetNewbuildingPromoPinsForMapOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetNewbuildingPromoPinsForMapResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetNewbuildingPromoPinsForMapModel(parameters),
    config,
  )) as FetchResponse<TGetNewbuildingPromoPinsForMapResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetNewbuildingPromoPinsForMapResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetNewbuildingPromoPinsForMapResponse>;
}
